/* tslint:disable */

declare var Object: any;
export interface NumeradorInterface {
  "idNumerador"?: number;
}

export class Numerador implements NumeradorInterface {
  "idNumerador": number;
  constructor(data?: NumeradorInterface) {
    Object.assign(this, data);
  }
  /**
   * The name of the model represented by this $resource,
   * i.e. `Numerador`.
   */
  public static getModelName() {
    return "Numerador";
  }
  /**
  * @method factory
  * @author Jonathan Casarrubias
  * @license MIT
  * This method creates an instance of Numerador for dynamic purposes.
  **/
  public static factory(data: NumeradorInterface): Numerador{
    return new Numerador(data);
  }
  /**
  * @method getModelDefinition
  * @author Julien Ledun
  * @license MIT
  * This method returns an object that represents some of the model
  * definitions.
  **/
  public static getModelDefinition() {
    return {
      name: 'Numerador',
      plural: 'Numeradors',
      path: 'Numeradors',
      idName: 'idNumerador',
      properties: {
        "idNumerador": {
          name: 'idNumerador',
          type: 'number'
        },
      },
      relations: {
      }
    }
  }
}



// WEBPACK FOOTER //
// E:/R1/Angular/turnero/web-visor-cliente/src/app/shared/lb-sdk/models/Numerador.ts